// extracted by mini-css-extract-plugin
export default {"delete_position_modal":"DeletePositionModal_delete_position_modal__bu8yU"};